<template>
  <section class="is-medium search-input" :class="{ hero: displayHeroTitle }">
    <div class="searchbar hero-body">
      <h2
        v-if="displayHeroTitle"
        class="is-size-3-desktop is-size-4-mobile has-text-centered has-text-light"
      >
        Compara precios de miles de productos
      </h2>
      <b-field>
        <b-autocomplete
          size="is-medium"
          expanded
          v-model.trim="searchQuery"
          :data="filteredDataArray"
          placeholder="Buscar..."
          icon="magnify"
          @select="option => (selected = option)"
          @keyup.enter="onClickSearch"
          :loading="isAlbumLoading"
        ></b-autocomplete>
        <p class="control" v-if="searchQuery">
          <button @click="onClickClearSearch" class="button is-medium">
            <span class="emoji-color is-size-6">❌</span>
          </button>
        </p>
      </b-field>
    </div>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import hideVirtualKeyboard from "hide-virtual-keyboard";

export default {
  name: "TheSearchbar",
  data() {
    return {
      data: [],
      searchQuery: "",
      selected: null
    };
  },
  props: {
    displayHeroTitle: {
      type: [Boolean, String],
      required: false,
      default: true
    },
    recentSearch: {
      type: Array,
      required: true
    },
    newSearchQuery: {
      type: String,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  computed: {
    filteredDataArray() {
      return this.recentSearch.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.searchQuery.toLowerCase()) >= 0
        );
      });
    },
    ...mapGetters({
      isAlbumLoading: "IS_ALBUM_LOADING"
    })
  },
  mounted() {
    this.searchQuery = this.settings.initialSearchQuery;
    this.onClickSearch();
  },
  watch: {
    searchQuery: {
      handler: debounce(function(val) {
        if (val === "") {
          this.$store.commit("CLEAR_SEARCH");
        } else {
          if (val !== this.newSearchQuery) {
            this.onClickSearch();
          }
        }
      }, 1000)
    },
    newSearchQuery(val) {
      this.searchQuery = val;
    }
  },
  methods: {
    onClickSearch() {
      if (!this.searchQuery) return;
      this.$emit("clickSearch", this.searchQuery);
      hideVirtualKeyboard();
    },
    onClickClearSearch() {
      this.searchQuery = "";
      this.$emit("clickClearSearch");
    }
  }
};
</script>

<style>
.searchbar {
  width: 100%;
  max-width: 650px;
  margin: 0 auto;
}
p.control {
  margin: 0;
  padding: 0;
}
.search-input {
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.65) 0,
      rgba(0, 0, 0, 0) 160px
    ),
    url(https://i.imgur.com/OvDH9GF.jpg);
  background-position: center;
  background-size: cover;
}
</style>
